(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerQuickQuote',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load(response)
	{
		$('#liveplannerquickquote-children').change(function handleChildrenAgeFields(e) {
			$('.child_age_field').addClass('hidden');
			if ($(this).val() > 0) {
				for (let count = 1; count <= $(this).val(); count++) {
					$('#child_age_field-' + count).removeClass('hidden');
				}
			}
		});
	};
}(jQuery, window.Adzuki || {}));